import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: 150px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	/* position: absolute;
	bottom: 0; */
	background-color: #52A254;
	@media (max-width: 1000px) {
		font-size: 12px;
  }
`;
